<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="650px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      ref="smsForm"
      :model="formData"
      :rules="formRules"
      label-width="120px"
    >
      <el-form-item label="短信签名" prop="signature">
        <el-input v-model="formData.signature" placeholder="请输入短信签名，例如：【公司名称】" maxlength="20" />
        <div class="form-tip">签名内容需要包含【】符号，例如：【睿保物流】</div>
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveSms } from '@/api/custom-frontend'

export default {
  name: 'SmsEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    smsData: {
      type: Object,
      default: null
    },
    appInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      submitLoading: false,
      formData: {
        signature: ''
      },
      formRules: {
        signature: [
          { required: true, message: '请输入短信签名', trigger: 'blur' },
          { min: 2, max: 20, message: '签名内容长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    
    dialogTitle() {
      return this.smsData ? '编辑短信签名' : '添加短信签名'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    initFormData() {
      if (this.smsData) {
        this.formData = {
          id: this.smsData.id,
          signature: this.smsData.signature
        }
      } else {
        this.formData = {
          signature: ''
        }
      }
    },
    
    async handleSubmit() {
      try {
        await this.$refs.smsForm.validate()
        
        this.submitLoading = true
        const submitData = {
          ...this.formData,
          app_id: this.appInfo.id
        }
        
        const res = await saveSms(submitData)
        if (res && res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('refresh')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存短信签名失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.submitLoading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.$refs.smsForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  line-height: 1.4;
}
</style>
